var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"mt-4"},[_c('b-row',[_c('b-col',{domProps:{"innerHTML":_vm._s(_vm.page.content)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }